import {
  CREATE_WORKFLOW_DESIGN_REQUEST,
  CREATE_WORKFLOW_DESIGN_SUCCESS,
  CREATE_WORKFLOW_DESIGN_FAILURE,
  GET_WORKFLOW_DESIGN_TICKET_REQUEST,
  GET_WORKFLOW_DESIGN_TICKET_SUCCESS,
  GET_WORKFLOW_DESIGN_TICKET_FAILURE,
  LIST_WORKFLOW_DESIGN_TICKETS_REQUEST,
  LIST_WORKFLOW_DESIGN_TICKETS_SUCCESS,
  LIST_WORKFLOW_DESIGN_TICKETS_FAILURE,
  UPDATE_WORKFLOW_DESIGN_TICKET_REQUEST,
  UPDATE_WORKFLOW_DESIGN_TICKET_SUCCESS,
  UPDATE_WORKFLOW_DESIGN_TICKET_FAILURE,
  DELETE_WORKFLOW_DESIGN_TICKET_REQUEST,
  DELETE_WORKFLOW_DESIGN_TICKET_SUCCESS,
  DELETE_WORKFLOW_DESIGN_TICKET_FAILURE,
  CHECK_WORKFLOW_DESIGN_STATUS_REQUEST,
  CHECK_WORKFLOW_DESIGN_STATUS_SUCCESS,
  CHECK_WORKFLOW_DESIGN_STATUS_FAILURE,
} from "../actions/workflowDesignSubmissionActions";

const initialState = {
  tickets: [],
  currentTicket: null,
  loading: false,
  error: null,
  successMessage: null,
  stats: null,
  statusCheck: null,
  totalCount: 0,
  hasMore: false,
};

const workflowDesignSubmissionReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create Workflow Design
    case CREATE_WORKFLOW_DESIGN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };

    case CREATE_WORKFLOW_DESIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: [...state.tickets, action.payload],
        currentTicket: action.payload,
        successMessage:
          "Workflow design submitted successfully! Your AI automation is being processed.",
        error: null,
      };

    case CREATE_WORKFLOW_DESIGN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get Workflow Design Ticket
    case GET_WORKFLOW_DESIGN_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        currentTicket: null,
      };

    case GET_WORKFLOW_DESIGN_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        currentTicket: action.payload,
        error: null,
      };

    case GET_WORKFLOW_DESIGN_TICKET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        currentTicket: null,
      };

    // List Workflow Design Tickets
    case LIST_WORKFLOW_DESIGN_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LIST_WORKFLOW_DESIGN_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action.payload.tickets || [],
        totalCount: action.payload.totalCount || 0,
        hasMore: action.payload.hasMore || false,
        error: null,
      };

    case LIST_WORKFLOW_DESIGN_TICKETS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Update Workflow Design Ticket
    case UPDATE_WORKFLOW_DESIGN_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };

    case UPDATE_WORKFLOW_DESIGN_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: state.tickets.map((ticket) =>
          ticket.ticketId === action.payload.ticketId
            ? { ...ticket, ...action.payload }
            : ticket
        ),
        currentTicket:
          state.currentTicket?.ticketId === action.payload.ticketId
            ? { ...state.currentTicket, ...action.payload }
            : state.currentTicket,
        successMessage: "Workflow design ticket updated successfully!",
        error: null,
      };

    case UPDATE_WORKFLOW_DESIGN_TICKET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Delete Workflow Design Ticket
    case DELETE_WORKFLOW_DESIGN_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };

    case DELETE_WORKFLOW_DESIGN_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: state.tickets.filter(
          (ticket) => ticket.ticketId !== action.payload.ticketId
        ),
        currentTicket:
          state.currentTicket?.ticketId === action.payload.ticketId
            ? null
            : state.currentTicket,
        successMessage: "Workflow design ticket deleted successfully!",
        error: null,
      };

    case DELETE_WORKFLOW_DESIGN_TICKET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Check Workflow Design Status
    case CHECK_WORKFLOW_DESIGN_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        statusCheck: null,
      };

    case CHECK_WORKFLOW_DESIGN_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        statusCheck: action.payload,
        error: null,
      };

    case CHECK_WORKFLOW_DESIGN_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        statusCheck: null,
      };

    // Clear messages
    case "CLEAR_WORKFLOW_DESIGN_MESSAGES":
      return {
        ...state,
        error: null,
        successMessage: null,
        statusCheck: null,
      };

    // Clear current ticket
    case "CLEAR_CURRENT_WORKFLOW_DESIGN_TICKET":
      return {
        ...state,
        currentTicket: null,
      };

    // Update ticket status (for real-time updates)
    case "UPDATE_TICKET_STATUS":
      return {
        ...state,
        tickets: state.tickets.map((ticket) =>
          ticket.ticketId === action.payload.ticketId
            ? { ...ticket, status: action.payload.status }
            : ticket
        ),
        currentTicket:
          state.currentTicket?.ticketId === action.payload.ticketId
            ? { ...state.currentTicket, status: action.payload.status }
            : state.currentTicket,
      };

    default:
      return state;
  }
};

export default workflowDesignSubmissionReducer;
